<template>
	<div class="scroll-frame">
		<div class="scroll-frame-head">
			<div class="head-title">
				<div class="fd-flow">
					<sym-icon name="replan" />
					<span class="fd-text">{{env.msg("contact.replan")}}: {{subject}}</span>
				</div>
				<div v-if="errors && errors.length>0">
					<api-error level="SEVERE" :message="errorMessage"></api-error>
				</div>
			</div>
		</div>	
		<div class="scroll-frame-body">
			<table class="agenda" style="font-size: small;">
				<thead>
				<tr>
					<td colspan="16" >{{env.msg("contact.reason")}}:
						<select v-model="reason" tabindex='10'>
							<option v-for="item in reasons" :key="item.value" :value="item.value">{{ item.name }}</option>
						</select>
					</td>
				</tr>
				</thead>
				<tbody>						
					<tr v-for="day in dayRange()" :class="rowClass(day)">
						<td :class="titleClass(day)" >
							<span class="thick">{{shortName(day)}}:</span>
						</td>
						<td style="text-align: right; padding-right:12px">
							<a @click="replan(day,0)">{{numberName(day)}}</a>
						</td>
						<td v-for="hour in hourRange()">
							<a @click="replan(day,hour)">
								{{ hour }}<sup style="font-size: 7px;">00</sup>
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="scroll-frame-tail">	
			<div class="tablepager">
				<div class="tablepager-content">
					<span class="pagercontrols"></span>
					<span class="tablesetting" ></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, reactive} from 'vue';
import type {ErrorMap} from "@fd/PartInjectKeys";
import {injectEnv} from "@fd/Environment.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ApiError from "@/fd/helpers/ApiError.vue";
import {formatDate} from "@t/util/DateUtil";

const props = defineProps({
	subject: String,
	maxDays: { type: Number, default: 20 },
	minHours: { type: Number, default: 6 },
	maxHours: { type: Number, default: 20 },
});	

const emit = defineEmits(['replan']);
const env = injectEnv();

//constants
const TODAY = new Date();
//properties
const errors = reactive<ErrorMap>([]);
const reasons = ref([]);
const reason = ref("");


function hourRange() {
  return Array.from({ length: props.maxHours - props.minHours }, (_, i) => props.minHours + i);
}

function dayRange() {
  return Array.from({ length: props.maxDays }, (_, i) => i);
}

function rowClass(index: number): string {
	return index % 2 === 0 ? "evenrow" : "oddrow";
}

function titleClass(day: number): string {
	var thisDay = getDate(day);
	//weekend
	return (thisDay.getDay() ===0 || thisDay.getDay()===6) ? "dimmed" : "";
}

function getDate(day: number): Date {
	var thisDay = new Date(TODAY);
	thisDay.setDate(thisDay.getDate() + day);
	return thisDay;
}

function shortName(day: number): string {
	var thisDay = getDate(day);
	return thisDay.toLocaleDateString('cs-CZ', { weekday: 'short' });
}

function numberName(day: number): string {
	var thisDay = getDate(day);
	return `${thisDay.getDate()}.${thisDay.getMonth()+1}.`;
}

function getReasonTitle(): string {
	if (reason.value) {
		const found = reasons.value.find(item => item.value === reason.value);
		if (found) return found.name;
	}
	return "-";
}

function replan(day: number, hours: number): void {
	var thisDay = getDate(day);
	thisDay.setHours(hours); 
	thisDay.setMinutes(0); 
	thisDay.setSeconds(0); 
	thisDay.setMilliseconds(0);
	//console.log("emit replan:"+reason.value+", date:"+formatDate(thisDay,hours>0,false));
	emit('replan',getReasonTitle(), formatDate(thisDay,hours>0,false));
}

const errorMessage = computed(() => {
	let erfMes = env.msg('catch.title');
	if (errors.length>0) {
		erfMes = erfMes+": "+errors[0].message;
	}
	return erfMes;
});

function loadData(): void {
	errors.length = 0;
	reasons.value =[];
	fetch("./api/lists/repl?onlyEnabled=true")
	.then(response => response.json())
	.then(data => {
		if (data !== null && data !== undefined && data.items) {
			reasons.value = data.items;
		}
		else {
			if (data !== null && data !== undefined && data.problems) {
				errors.push(data.problems[0]);
			}
			else {
				errors.push({level:"SEVERE", message:env.msg("suggest.error")});
			}
		}
	})
	.catch((error) => {
		console.log("Error loading consent's list:"+error);
		errors.push({level:"SEVERE",message: error});
	});
}

onMounted(() => {
	loadData();
});
</script>

<style>

</style>
